module.exports = __webpack_public_path__ + "img/project16_2.jpg.5b666fd4.webp";